import { DATA_GRID_LAZY_PAGE_SIZE } from '@/components/DataGrid/definitions';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useInfiniteQuery } from '../useInfiniteQuery';

export const REPORT_GROUPS_QUERY_KEY = 'reports.listReportGroups';

export const getReportGroupsQueryKey = ({
  id,
  page,
  perPage,
  tenantId,
}: {
  id?: string;
  page?: string | number;
  perPage?: string | number;
  tenantId?: string;
} = {}) => [
  REPORT_GROUPS_QUERY_KEY,
  {
    id,
    page: +(page ?? 1),
    perPage: +(perPage ?? DATA_GRID_LAZY_PAGE_SIZE),
    tenantId,
  },
];

export const useInfiniteReportGroups = ({ id, enabled }: { id?: string; enabled?: boolean }) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useInfiniteQuery({
    queryKey: parameters => getReportGroupsQueryKey({ id, tenantId, ...parameters }),
    queryFunction: (parameters: { page?: number; perPage?: number }) =>
      api.reports.getReportGroups({ tenantId, id: id ?? '', ...parameters }),
    dataKey: 'groups',
    options: {
      enabled: !!id && !!tenantId && (enabled ?? true),
    },
  });
};
